var map = {
	"./ca.json": [
		18208,
		8208
	],
	"./de.json": [
		85627,
		5627
	],
	"./en.json": [
		48083,
		8083
	],
	"./fr.json": [
		6083,
		8464
	],
	"./uk.json": [
		22448,
		2448
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57146;
module.exports = webpackAsyncContext;